import Cookies from "js-cookie";
import { ENV } from "./env";

const domain = globalThis.location.hostname.includes("rtd-denver.com")
  ? ".rtd-denver.com"
  : undefined;

// Explicit list — iterating all cookies would clear OTHER envs' state (shared .rtd-denver.com).
const COOKIE_BASES = ["token", "ssoIdentifier", "userDivisions", "connect.sid"];

// Clears SPA-side state only; no navigation.
export const clearLocalSession = () => {
  sessionStorage.clear();
  localStorage.clear();

  COOKIE_BASES.forEach((base) => {
    Cookies.remove(`${base}.${ENV}`, { path: "/", domain });
    Cookies.remove(base, { path: "/", domain });
  });
};

// Voluntary logout: full MSAL teardown + cross-env coordination via /logout.
export const redirectToAuthServer = () => {
  globalThis.location.href = `${process.env.REACT_APP_AUTH_URL}/logout?app=bus_assignments`;
};

// 401-recovery: skip /logout (nothing left to tear down) and go straight
// to /login. See changes/decisions/2026-05-14_signed-out-splash.md.
export const redirectToLogin = () => {
  globalThis.location.href = `${process.env.REACT_APP_AUTH_URL}/login?app=bus_assignments`;
};

const handleLogout = () => {
  clearLocalSession();
  redirectToAuthServer();
};

export default handleLogout;
